import { render, staticRenderFns } from "./LbaCheckbox.vue?vue&type=template&id=d3c7bfde"
import script from "./LbaCheckbox.vue?vue&type=script&lang=js"
export * from "./LbaCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports